import styles from "./MedicalItemCardList.module.scss";

export function MedicalItemCardList(props: Readonly<{ children: JSX.Element[] }>): JSX.Element {
    return (
        <ul className={styles.list}>
            {props.children}
        </ul>
    );
}
